import React from "react"
import types from "prop-types"
import clsx from "clsx"
import FormIcon from "shared/icons/FormIcon"
import ItemRow from "shared/ItemRow"
import { formShape } from "utils/propTypeShapes"

const notOnLandingPageDescription = (form) => {
  if (form.active && form.listed) return ""
  if (form.active && !form.listed) return "unlisted"
  if (!form.active && form.listed) return "inactive"

  return "inactive, unlisted"
}

const FormBar = ({ form, handle = undefined }) => {
  const notOnLandingPage = !(form.active && form.listed)

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <>
          <div className="flex gap-4">
            <span>{handle}</span>
            <div className="flex items-center gap-2">
              <FormIcon form={form} className={clsx("w-8 h-8", notOnLandingPage && "opacity-40")} />
              <span className={clsx(notOnLandingPage && "text-dark")}>{form.title}</span>
            </div>
          </div>
          {
            notOnLandingPage && (
              <span className="text-sm text-dark">{notOnLandingPageDescription(form)}</span>
            )
          }
        </>
      )}
    />
  )
}

FormBar.propTypes = {
  form: formShape.isRequired,
  handle: types.node,
}

export default FormBar
